import adapter from '@flopflip/memory-adapter';
import { createFlopFlipEnhancer } from '@flopflip/react-redux';
import _ from 'lodash';
import { __DO_NOT_USE__ActionTypes, applyMiddleware, compose, createStore } from 'redux';

import { IS_PRODUCTION } from 'constants/envs';
import { adapterArgs } from 'constants/featureFlags';

import middlewares from './middlewares';
import createReducer from './reducers';
/*
Fix for Firefox redux dev tools extension
https://github.com/zalmoxisus/redux-devtools-instrument/pull/19#issuecomment-400637274
 */
__DO_NOT_USE__ActionTypes.REPLACE = '@@redux/INIT';

const composeEnhancers =
  !IS_PRODUCTION && _.isObject(window) && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 50,
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const enhancer = composeEnhancers(
  applyMiddleware(...middlewares),
  createFlopFlipEnhancer(adapter, adapterArgs),
);

const store = createStore(createReducer(), enhancer);

store.asyncReducers = {};

export default store;
